export default __webpack_public_path__ + "static/sandsoftime-db449af39aed656c1adcaa07b50ef348.jpg";